import { useRouter } from 'next/dist/client/router';

type NumberFormattingType = 'percent' | 'decimal';
type Formatter = (value: number) => string;

/**
 * Locale-based number formatting.
 *
 * Type 'percent' expects a percentage in decimal representation (eg. 1 will be formatted to 100%, 0.35 to 35%).
 * Type 'decimal' expects any number in decimal representation (eg. 10000 will be formatted 10.000).
 *
 * @param type {'percent' | 'decimal'} - number type
 * @returns {(value: number) => string} formatter function
 */
export function useNumberFormatting(type: NumberFormattingType): Formatter {
  const router = useRouter();

  // Default formatter casts number to string;
  let format = (n: number) => String(n);

  if (type === 'percent') {
    const formatter = new Intl.NumberFormat(router.locale, { style: 'percent' });
    format = formatter.format;
  }

  if (type === 'decimal') {
    const formatter = new Intl.NumberFormat(router.locale, { style: 'decimal' });
    format = formatter.format;
  }

  return format;
}
